import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import CheckDiffText from './CheckDiffText'
class PortRestrictions extends React.Component {
    constructor(props) {
       super(props);
    }

    render() {
        const { port, newPort } = this.props;

        return (
            <Fragment>
                <div className="main__title">
                    PORT Restrictions
                </div>

                <div className="port-restrictions">
                        <div className="list">
                            <div className="item">
                                <div>Max Draft, m:</div>
                                <CheckDiffText
                                    oldValue={port.portLimitations.maxDraught}
                                    newValue={newPort.portLimitations ? newPort.portLimitations.maxDraught : null}
                                />
                            </div>
                            <div className="item">
                                <div>Max Beam, m:</div>
                                <CheckDiffText
                                    oldValue={port.portLimitations.maxBeam}
                                    newValue={newPort.portLimitations ? newPort.portLimitations.maxBeam : null}
                                />
                            </div>
                            <div className="item">
                                <div>Max LOA, m:</div>
                                <CheckDiffText
                                    oldValue={port.portLimitations.maxLOA}
                                    newValue={newPort.portLimitations ? newPort.portLimitations.maxLOA : null}
                                />
                            </div>
                            <div className="item">
                                <div>Max DWT, mt:</div>
                                <CheckDiffText
                                    oldValue={port.portLimitations.maxDWT}
                                    newValue={newPort.portLimitations ? newPort.portLimitations.maxDWT : null}
                                />
                            </div>
                            <div className="item">
                                <div>Channel Depth, m:</div>
                                <CheckDiffText
                                    oldValue={port.portLimitations.channelDepth}
                                    newValue={newPort.portLimitations ? newPort.portLimitations.channelDepth : null}
                                />
                            </div>
                            <div className="item">
                                <div>Anchorage Depth, m:</div>
                                <CheckDiffText
                                    oldValue={port.portLimitations.anchorageDepth}
                                    newValue={newPort.portLimitations ? newPort.portLimitations.anchorageDepth : null}
                                />
                            </div>
                            <div className="item">
                                <div>Mean Tide, m:</div>
                                <CheckDiffText
                                    oldValue={port.portLimitations.meanTide}
                                    newValue={newPort.portLimitations ? newPort.portLimitations.meanTide : null}
                                />
                            </div>
                        </div>
                </div>
            </Fragment>)

    }
}

PortRestrictions.propTypes = {

};

PortRestrictions.defaultProps = {

};

export default connect(
    (state, { port, newPort }) => {

        return {
           port,
           newPort,
        };
    },
    dispatch => bindActionCreators({

    }, dispatch),
)(PortRestrictions);


// WEBPACK FOOTER //
// ./app/components/Regions/PortApprove/PortRestrictions.jsx